import axios from 'axios';


// const baseDomain = 'https://apitest.scc.az';
// const mediaDomain = 'https://filetest.scc.az';
// const paymentApi = 'https://paytest.scc.az';

const baseDomain = 'https://apiv7.scc.az';
const mediaDomain = 'https://filev7.scc.az';
const paymentApi = 'https://pay.scc.az';


export const customHeaders = {
    'Content-Type': 'application/json;charset=utf-8',
    'Accept': 'application/json',
    'language': localStorage.getItem("userLang") || 'az'
};

export const baseUrl = `${baseDomain}`;
export const mediaBase = `${mediaDomain}`;
export const paymentDomain = `${paymentApi}`;

export default axios.create({
    baseUrl,
    headers: customHeaders
});

export const serializeQuery = query => {
    return Object.keys(query)
        .map(
            key =>
                `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`
        )
        .join('&');
};
